export default "/_next/static/images/map-f88b18b3a7d07eb82c116fae0b5205fd.jpg";